import * as React from "react";
import PropTypes from "prop-types";

import "./counter.css";

const Counter = ({ value, setValue, minValue, maxValue }) => (
  <div>
    <button
      type="button"
      styleName={"counter-button" + (value === minValue ? " disabled" : "")}
      disabled={value === minValue}
      onClick={() => setValue(Math.max(minValue, value - 1))}
    >
      -
    </button>
    <span styleName="value">{value}</span>
    <button
      type="button"
      styleName={"counter-button" + (value === maxValue ? " disabled" : "")}
      disabled={value === maxValue}
      onClick={() => setValue(Math.min(maxValue, value + 1))}
    >
      +
    </button>
  </div>
);

Counter.propTypes = {
  value: PropTypes.number.isRequired,
  setValue: PropTypes.func.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired
};

export default Counter;
